import Vue from 'vue'
import Router from 'vue-router'
import authService from './services/auth.service'

// Views
import BrokerDashboard from './views/BrokerDashboard.vue'
import BrokerLogin from './views/BrokerLogin.vue'
import BrokerCompetitions from './views/BrokerCompetitions.vue'
import BrokerMembers from './views/BrokerMembers.vue'
import BrokerProfile from './views/BrokerProfile.vue'
import CompetitionOverview from './views/CompetitionOverview.vue'
import BrokerClubs from './views/BrokerClubs.vue'
import CommunityWizardView from './views/CommunityWizardView.vue'
import LeagueRankingView from './views/LeagueRankingView.vue'
import PublicLeagueView from './views/PublicLeagueView.vue'
import ServersGroupsView from './views/ServersGroupsView.vue'
import OneVsOneView from './views/OneVsOneView.vue'
import QuestsView from './views/QuestsView.vue'
import RankingView from './views/RankingView.vue'


// Reuse traders' app club components
import ClubIndex from '@/views/Community/views/ClubIndex.vue'
import ClubDashboard from '@/views/Community/components/ClubDashboard.vue'
import ClubSettings from '@/views/Community/components/ClubSettings.vue'
import ClubEvents from '@/views/Community/components/ClubEvents.vue'
import ClubMembers from '@/views/Community/components/ClubMembers.vue'
import ClubTournaments from '@/views/Community/components/ClubTournaments.vue'
import ClubPerformance from '@/views/Community/components/ClubPerformance.vue'
import ClubLeague from '@/views/Community/components/ClubLeague.vue'

// Tournament overview wrapper
import TournamentOverviewWrapper from './views/TournamentOverviewWrapper.vue'

// Tournament settings (reuse from traders app)
import TournamentSettingsView from '@/views/Tournament/Settings/views/TournamentSettingsView.vue'

// Shared journal (reuse from traders app)
import TradingJournal from '@/views/Journal/TradingJournal.vue'
import SharedJournalHome from '@/views/Community/views/SharedJournalHome.vue'

import  BrokerAuthShell  from "./components/BrokerAuthShell.vue";
import  SignUpNewUserOne  from "./components/Log/SignUpNewUserOne.vue";
import  SignUpNewUserTwo  from "./components/Log/SignUpNewUserTwo.vue";


Vue.use(Router)

// Always serve at root for broker app
const basePath = '/'

const router = new Router({
  mode: 'history',
  base: basePath,
  routes: [
    {
      path: '/login',
      name: 'broker-login',
      component: BrokerLogin,
      meta: {
        public: true,
        layout: 'auth'
      }
    },
        {
      path: '/signup',
      name: 'broker-login',
      component: BrokerAuthShell,
      meta: {
        public: true,
        layout: 'auth'
      }
    },
    {
      path: '/signupone',
      name: 'SignUpNewUserOne',
      component: SignUpNewUserOne,
    },
    {
      path: '/signuptwo',
      name: 'SignUpNewUserTwo',
      component: SignUpNewUserTwo,
    },
    {
      path: '/',
      name: 'broker-dashboard',
      component: BrokerDashboard,
      meta: {
        requiresAuth: true,
        title: 'Dashboard'
      }
    },
    {
      path: '/competitions',
      name: 'broker-competitions',
      component: BrokerCompetitions,
      meta: {
        requiresAuth: true,
        title: 'Competitions'
      },
      children: [
        {
          path: 'rank/:competitionId(\\d+)',
          name: 'broker-competition-rank',
          components: {
            overlay: CompetitionOverview
          },
          props: {
            overlay: route => ({ competitionId: Number(route.params.competitionId) })
          },
          meta: { requiresAuth: true, title: 'Competition Rank' }
        }
      ]
    },
    {
      path: '/members',
      name: 'broker-members',
      component: BrokerMembers,
      meta: {
        requiresAuth: true,
        title: 'Members'
      }
    },
    {
      path: '/clubs',
      name: 'broker-clubs',
      component: BrokerClubs,
      meta: {
        requiresAuth: true,
        title: 'Clubs'
      }
    },
    {
      path: '/clubs/create',
      name: 'broker-create-community',
      component: CommunityWizardView,
      meta: {
        requiresAuth: true,
        title: 'Create Community',
        hideBreadcrumb: true
      }
    },
    {
      path: '/leagues/public',
      name: 'public-league',
      component: PublicLeagueView,
      meta: {
        public: true,
        title: 'League Ranking'
      }
    },
    {
      path: '/leagues',
      name: 'broker-leagues',
      component: RankingView,
      meta: {
        requiresAuth: true,
        title: 'Leagues'
      }
    },
    {
      path: '/servers',
      name: 'broker-servers',
      component: ServersGroupsView,
      meta: {
        requiresAuth: true,
        title: 'Platform Servers & Groups'
      }
    },
    {
      path: '/club',
      component: ClubIndex,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'Community'
      },
      children: [
        {
          path: '',
          name: 'broker-club-dashboard',
          component: ClubDashboard,
        },
        {
          path: 'settings',
          name: 'broker-club-settings',
          component: ClubSettings,
        },
        {
          path: 'events',
          name: 'broker-club-events',
          component: ClubEvents,
        },
        {
          path: 'tournaments',
          name: 'broker-club-tournaments',
          component: ClubTournaments,
        },
        {
          path: 'league',
          name: 'broker-club-league',
          component: ClubLeague,
        },
        {
          path: 'members',
          name: 'broker-club-members',
          component: ClubMembers,
        },
        {
          path: 'performance',
          name: 'broker-club-performance',
          component: ClubPerformance,
        }
      ]
    },
        {
      path: '/onevsone',
      name: 'broker-onevsone',
      component: OneVsOneView,
      meta: {
        requiresAuth: true,
        title: 'Platform Servers & Groups'
      }
    },
        {
      path: '/quests',
      name: 'broker-quests',
      component: QuestsView,
      meta: {
        requiresAuth: true,
        title: 'Platform Servers & Groups'
      }
    },
    {
      path: '/tournament/:tournamentId(\\d+)',
      name: 'tournament-overview',
      component: TournamentOverviewWrapper,
      props: route => ({ tournamentId: Number(route.params.tournamentId) }),
      meta: {
        requiresAuth: true,
        title: 'Tournament Overview'
      }
    },
    {
      path: '/tournament/:tournamentId(\\d+)/settings',
      name: 'tournament-settings',
      component: TournamentSettingsView,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'Tournament Settings'
      }
    },
    {
      path: '/profile',
      name: 'broker-profile',
      component: BrokerProfile,
      meta: {
        requiresAuth: true,
        title: 'Profile'
      }
    },
    {
      path: '/book',
      component: TradingJournal,
      meta: { requiresAuth: true, title: 'Shared Journal' },
      children: [
        {
          path: 'shared',
          name: 'shared-journal',
          component: SharedJournalHome,
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// Navigation guards
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isPublic = to.matched.some(record => record.meta.public)

  // Check authentication state from store/localStorage
  await authService.checkAuthState()
  const isAuthenticated = authService.isAuthenticated()
  const currentUser = authService.getCurrentUser()

  console.log('Router guard - isAuthenticated:', isAuthenticated, 'currentUser:', currentUser)

  if (requiresAuth && !isAuthenticated) {
    // Redirect to login with return URL
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else if (requiresAuth && currentUser) {
    // For broker app, we check roles from JWT
    // The user has roles like: ["ROLE_ADMIN", "ROLE_BROKER_ADMIN", "ROLE_USER"]
    const userRoles = currentUser.roles || []
    const isBroker = userRoles.some(role =>
      role.includes('BROKER') ||
      role.includes('ADMIN')
    )

    if (!isBroker) {
      console.warn('User does not have broker role, but staying in broker app')
      // For now, allow access since they authenticated through broker API
      // In production, you may want to show an access denied page
      next()
    } else {
      next()
    }
  } else if (isPublic && isAuthenticated) {
    // Already logged in, redirect to dashboard
    next('/')
  } else {
    next()
  }
})

// After navigation hook for page titles
router.afterEach((to) => {
  // Update document title
  const baseTitle = 'Swiset Broker Portal'
  document.title = to.meta.title ? `${to.meta.title} - ${baseTitle}` : baseTitle
})

export default router